import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  emailSubscription = '';
  isLoggedIn = false;

  constructor(private authService: AuthService, private router: Router) {
    this.authService.token$.subscribe((token) => {
      this.isLoggedIn = !!token;
    });
  }

  subscribe() {
    if (this.emailSubscription && this.validateEmail(this.emailSubscription)) {
      this.emailSubscription = '';
    } else {
      console.error('Invalid email address');
    }
  }

  validateEmail(email: string): boolean {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

  navigateWithScroll(route: string): void {
    this.router.navigateByUrl(route).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}
